import React from 'react';
import { InteractiveShape } from '../interactive/InteractiveShape';
import zoomUtils from '../../utils/ZoomUtils';
import storeManager from '../../../store/StoreManager';
import { hideMenus, setContextTarget } from '../../../actions/MenuActions';
import menuType from '../../../constants/MenuType';
import mouseUtils from '../../utils/MouseUtils';
import { selectShape } from '../../../actions/CurrentSlideActions';

export const Triangle = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        shapeModel: React.PropTypes.object.isRequired
    },
    isShapeSelected() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                if (shapes[i].isSelected == true)
                    return true;
                else
                    return false;
            }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render() {
        const { shapeModel, dispatch } = this.props;

        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var clipPathObject;
        var realWidth = shapeModel.width;
        var realHeight = shapeModel.height;
        var newShapeModel = shapeModel;
        var x1 = 0;
        var y1 = 0;
        var clipId = 'hotSpot_' + shapeModel.uuid;
        var clipPath = 'url(#' + clipId + ')';

        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);

            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;

            if (zoomUtils.isCroppingMode() && zoomUtils.croppingTarget.uuid == shapeModel.uuid) {
                newShapeModel = Object.assign({}, shapeModel);
                newShapeModel.width = realWidth;
                newShapeModel.height = realHeight;
                newShapeModel.x = shapeModel.x - x1;
                newShapeModel.y = shapeModel.y - y1;

                // x1=0;
                // y1=0;
            } else {
                clipPathObject = <clipPath id={clipId}>
                    <rect x={x1} y={y1} width={x2 - x1} height={y2 - y1}></rect>
                </clipPath>
            }
        }

        const path = `M${realWidth/2} 0 L${realWidth} ${realHeight} L0 ${realHeight} Z`;

        return (
            <InteractiveShape shapeModel={shapeModel} dispatch={dispatch} rotatable={true} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${newShapeModel.x} ${newShapeModel.y})`} opacity={shapeModel.opacity}>
                    {clipPathObject}
                    <g transform={`translate(${-x1} ${-y1})`}>
                        <path
                            d={path}
                            filter={newShapeModel.filter}
                            opacity={newShapeModel.opacity}
                            fill={newShapeModel.fill}
                            fillOpacity={backgroundOpacity}
                            stroke={newShapeModel.stroke}
                            strokeWidth={newShapeModel.strokeWidth}
                            strokeOpacity={newShapeModel.strokeOpacity}
                            preserveAspectRatio="none"
                            clipPath={clipPath} />
                    </g>
                    {
                        !shapeModel.isGrouped ?
                            <foreignObject>
                                <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                            </foreignObject >
                            : null
                    }
                </g>
            </InteractiveShape>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Triangle.js
 **/